import React from 'react';

function App() {
  return (
    <div className="App">
      <h1>This is a totally empty react file.</h1>
      {/* Add your components here */}
    </div>
  );
}

export default App;
